import { useState, type ReactNode } from 'react';
import { IconButton, InputAdornment, TextField, type TextFieldProps, type InputProps } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

export type HFTextFieldProps = TextFieldProps;

export function HFTextField({ type, slotProps, ...props }: HFTextFieldProps) {
  const [showPassword, setShowPassword] = useState(false);
  const isPassword = type === 'password';
  const resolvedType = isPassword ? (showPassword ? 'text' : 'password') : type;

  const passwordAdornment = isPassword ? (
    <InputAdornment position="end">
      <IconButton
        aria-label={showPassword ? 'Hide password' : 'Show password'}
        onClick={() => setShowPassword((value) => !value)}
        onMouseDown={(event) => event.preventDefault()}
        edge="end"
        size="small"
      >
        {showPassword ? <VisibilityOffIcon fontSize="small" /> : <VisibilityIcon fontSize="small" />}
      </IconButton>
    </InputAdornment>
  ) : null;

  const incomingInput = (slotProps?.input ?? {}) as Partial<InputProps> & Record<string, unknown>;

  return (
    <TextField
      fullWidth
      variant="outlined"
      type={resolvedType}
      {...props}
      slotProps={{
        ...slotProps,
        input: {
          ...incomingInput,
          endAdornment: (passwordAdornment ?? incomingInput.endAdornment) as ReactNode,
        },
      }}
    />
  );
}
